/*
 * @Author: 右侧内容重构
 * @Date:   2017-09-11 16:07:27
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-10-23 20:47:09
 */

'use strict';
angular.module('themeDetailModule', []).directive('themeDetail', [
    '$state',
    '$location',
    '$timeout',
    '$stateParams',
    '$sce',
    'trsspliceString',
    'resCtrModalService',
    'resourceCenterService',
    'modalDialog',
    'trsHttpService',
    'ueditorService',
    'storageListenerService',
    function(
        $state,
        $location,
        $timeout,
        $stateParams,
        $sce,
        trsspliceString,
        resCtrModalService,
        resourceCenterService,
        modalDialog,
        trsHttpService,
        ueditorService,
        storageListenerService,
    ) {
        // Runs during compile
        return {
            scope: {
                rebuildData: '=',
            },
            restrict: 'AE',
            templateUrl: './resourceCenter/stock/quickPreview/detail/detail_tpl.html',
            replace: true,
            link: function(scope, iElm, iAttrs, controller) {
                initStatus();
                initData();
                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        currModule: 'jtcpg',
                        channelType: $stateParams.channeltype,
                        guid: $stateParams.guid,
                    };
                    scope.basicParams = {
                        channelName: scope.status.currModule,
                        typeName: $stateParams.typename,
                        nodeId: $stateParams.nodeid,
                    };
                    scope.data = {
                        selectedArray: [],
                        picList: [],
                        videoList: [],
                    };
                    scope.detailData = {};
                    scope.params = {
                        serviceid: scope.status.currModule,
                        modelid: 'detailData',
                        channelName: scope.status.currModule,
                        guid: scope.status.guid,
                        typeid: 'zyzx',
                    };
                }

                /**
                 * [initData description]初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    if (angular.isDefined(scope.rebuildData)) {
                        scope.params.guid = scope.rebuildData.guid;
                        requestData();
                    }
                }
                /**
                 * [requestData description]获取数据
                 * @return {[type]} [description]
                 */
                function requestData() {
                    if (!$stateParams.guid) {
                        return;
                    }
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), scope.params, 'post').then(function(data) {
                        if (data && data.content) {
                            scope.detailIndexname = data.summary_info.indexName;
                            scope.detailData = data.content[0];
                            setPicList();
                            setVideoList();
                            scope.detailData.CONTENT = ueditorService.replaceHtmlBlank(scope.detailData.CONTENT); //将html正文中的半角空格换成全角空格
                            scope.detailData.CONTENT = scope.detailData.CONTENT.replace(
                                /(<(?:p|div)[^>]*>(?:<(?:span|b)[^>]*>)*)(?:&nbsp;| |　)*/gi,
                                '$1　　'
                            )
                                .replace(/(<br[^>]*>)(?:&nbsp;| |　)*/gi, '$1　　')
                                .replace(/>　　</g, '><')
                                .replace(/text-indent:[^>]*em/g, 'text-indent:0em')
                                .replace('crossorigin="anonymous"', '');

                            scope.detailData.CONTENT = data.content[0] && $sce.trustAsHtml(scope.detailData.CONTENT);
                            scope.detailData.keywordsArr = scope.detailData.ZB_KEYWORDS5 === '' ? [] : scope.detailData.ZB_KEYWORDS5.split(';');

                            // getRelatedHotwords();
                            /*
                            getTenantId().then(function() {
                            getRelatedLeaders();
                            getRelevantDraft();
                            getGroupReprint();
                            });*/
                            /*
                            if (channelName == "wb") {
                             getWeiboImg();
                            }*/
                        }
                    });

                    /*
                    initQqjccInfos();
                    showSourceSite();
                    */
                }

                /**
                 * [setPicList 设置图集稿图片列表]
                 *
                 * @return  {[type]}  [return description]
                 */
                function setPicList() {
                    if (scope.detailData.DOC_TYPE === '2') {
                        var str = scope.detailData.IMGURLS;
                        scope.data.picList = JSON.parse(str);
                        let setList = [];
                        scope.data.picList.forEach((item, index) => {
                            let check = false;
                            if (index === 0) {
                                check = true;
                            }
                            setList.push({
                                PERPICURL: item.imgurl,
                                active: check,
                                APPDESC: item.ts,
                            });
                        });
                        scope.data.picList = setList;
                    }
                }


                /**
                 * [setVideoList 设置视频稿视频列表]
                 *
                 * @return  {[type]}  [return description]
                 */
                function setVideoList() {
                    var str = scope.detailData.IR_VIEDO_URL;
                    let videoList = JSON.parse(str);
                    videoList.forEach(function(item,index){
                      if (item.videoUrl !== ''){
                        if(scope.detailData.DOC_TYPE === '1'){
                          let str = 'videoid="' + item.videoid + '"';
                          if(scope.detailData.CONTENT.indexOf(str) !== -1){
                            let regex = new RegExp('<img[^<]*videoid=\\"' + item.videoid + '\\"[^>]*/>','ig');
                            let videoTag = '<video height="100%" controls src="' + item.videoUrl + '" poster="' + item.thumbImg + '"></video>';
                            scope.detailData.CONTENT = scope.detailData.CONTENT.replace(regex,videoTag);
                          }
                        }
                        scope.data.videoList.push(item);
                      }
                    });

                }

                /**
                 * [playVideoOrAudio description] 点击播放音视频
                 * @param   {[type]}  id    [id description] 音/视频
                 * @param   {[type]}  type  [type description] 被处理的项
                 * @return  {[type]}        [return description]
                 */
                scope.playVideoOrAudio = function (id,type, relationid,meiziid) {
                  ueditorService.videoPlayer(id, type,relationid,meiziid);
                };

                /**
                 * [openOriginalPic description] 查看完整图片
                 * @param  {[type]} url [description] 图片地址
                 * @return {[type]}     [description]
                 */
                scope.openOriginalPic = function(url) {
                    window.open(url);
                };
                /**
                 * [plainView description] 普通视图
                 * @return {[type]} [description]
                 */
                scope.plainView = function() {
                    $state.go('front.resourcectrl.theme.resource', $stateParams);
                };
                /**
                 * [openTakeDraftModal description] 取稿
                 * @return {[type]} [description]
                 */
                scope.openTakeDraftModal = function() {
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'fetch',
                        guid: scope.rebuildData.guid,
                        indexname: scope.detailIndexname,
                        channelName: scope.status.currModule,
                    };
                    var modalInstance = resCtrModalService.fullTakeDraft(params, true, [scope.rebuildData]);
                    modalInstance.result.then(
                        function(data) {
                            takeDraftDownloadImgs(data).then(function() {
                                storageListenerService.addListenerToResource('takeDraft');
                            });
                        },
                        function() {
                            storageListenerService.addListenerToResource('takeDraft');
                        }
                    );
                };
                /**
                 * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
                 * @param  {[type]} data [description]
                 * @return {[type]}      [description]
                 */
                function takeDraftDownloadImgs(data) {
                    var deferred = $q.defer();
                    var needDownloadImg = false;
                    for (var i = 0; i < data.REPORTS.length; i++) {
                        if (data.REPORTS[i].PICERROR == 1) {
                            needDownloadImg = true;
                            break;
                        }
                    }
                    if (needDownloadImg) {
                        resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                            deferred.resolve();
                        });
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                }
                //个人素材(稿件批量添加到个人素材)
                scope.CreationAxis = function() {
                    var params = {
                        typeid: 'zyzx',
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'batchPersonalMaterial',
                        channelName: scope.status.currModule, //栏目名称全拼结构
                        PersonalMaterialId: 0, //所属文件夹ID，默认根节点（0）
                        indexName: scope.detailIndexname,
                        guid: scope.rebuildData.guid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('添加成功', '', 'success', false, function() {});
                    });
                };
                /** 收藏*/
                scope.collect = function() {
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'collect',
                        guid: scope.rebuildData.guid,
                        indexname: scope.detailIndexname,
                        channelName: scope.status.currModule,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('收藏成功!', '', 'success', false, '');
                    });
                };
            },
        };
    },
]);
